"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CallBackKeys = /** @class */ (function () {
    function CallBackKeys() {
    }
    CallBackKeys.main_menu_key_logout = "user:logout";
    CallBackKeys.main_menu_key_profile = "user:profile";
    CallBackKeys.main_menu_key_test = "user:test";
    return CallBackKeys;
}());
exports.CallBackKeys = CallBackKeys;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/includes/cbkeys.ts
// module id = 763
// module chunks = 0